/**
 * True below 860px — the shell's tab-bar breakpoint (V98-3-1 [R3]); the
 * compact StageRail and Today's phone composition use the same line.
 */
import { useEffect, useState } from 'react';

export const NARROW_QUERY = '(max-width: 859px)';

export function useNarrow(): boolean {
  const [narrow, setNarrow] = useState(() => typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(NARROW_QUERY).matches);
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const q = window.matchMedia(NARROW_QUERY);
    const update = () => setNarrow(q.matches);
    update();
    q.addEventListener?.('change', update);
    return () => q.removeEventListener?.('change', update);
  }, []);
  return narrow;
}
